import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import {
  StyledContainer,
  StyledLegendsClip,
  StyledLegendsColorBox,
  StyledTitle,
} from './ChartLegends.styles';
import { ChartLegendsProps } from './ChartLegends.types';

const ChartLegends: React.FC<ChartLegendsProps> = ({
  data,
  colors,
  title,
  itemsContainerSx,
}) => {
  return (
    <Flex flexDirection='column' flex={1}>
      <StyledTitle variant='h6' fontWeight='fontWeightSemiBold'>
        {title}
      </StyledTitle>
      <StyledContainer sx={itemsContainerSx}>
        {data.map((item, index) => (
          <StyledLegendsClip key={item.id}>
            <StyledLegendsColorBox sx={{ bgcolor: colors[index] }} />
            <Text
              variant='body'
              fontWeight='fontWeightMedium'
              textAlign='center'
            >
              {item.id}
            </Text>
          </StyledLegendsClip>
        ))}
      </StyledContainer>
    </Flex>
  );
};

export default ChartLegends;
